export default {
    step: 1,
    currentComponent: "comprovante",
    dividas: [],
    acordo: {}
}